export default __webpack_public_path__ + "static/media/kitchen3-after2-768w.6f50a52a.png";